// Validate login form
function validateLoginForm(values) {
    const errors = {};

    // Email or Mobile validation
    const emailOrMobileRegex = /\S+@\S+\.\S+/;
    const mobileRegex = /^\d{10}$/;

    if (!values.emailnmobi.trim()) {
        errors.emailnmobi = "Please enter an email address or mobile number!";
    } else if (!emailOrMobileRegex.test(values.emailnmobi) && !mobileRegex.test(values.emailnmobi)) {
        errors.emailnmobi = "Please enter a valid email address or mobile number!";
    }

    // Password validation
    if (!values.passWord) {
        errors.passWord = "Password is required!";
    } else if (values.passWord.length < 6) {
        errors.passWord = "Password must be at least 6 characters long!";
    }

    return errors;
}
function validateForgotPasswordForm(values) {
    const errors = {};

    // Email validation
    const emailOrMobileRegex = /\S+@\S+\.\S+/;

    if (!values.emailnmobi.trim()) {
        errors.emailnmobi = "Please enter an email address!";
    } else if (!emailOrMobileRegex.test(values.emailnmobi)) {
        errors.emailnmobi = "Please enter a valid email address!";
    }

    return errors;
}

function validateResetPasswordForm(values) {
    const errors = {};
    // Password validation
    if (!values.passWord) {
        errors.passWord = "Password is required!";
    } else if (values.passWord.length < 6) {
        errors.passWord = "Password must be at least 6 characters long!";
    }
    if (!values.confirmpassWord) {
        errors.confirmpassWord = "Password is required!";
    } else if (values.confirmpassWord.length < 6) {
        errors.confirmpassWord = "Password must be at least 6 characters long!";
    }

    return errors;
}




// Validate registration form
function validateRegistrationForm(values, country) {
    const errors = {};

    // Full Name validation
    if (!values.fullName.trim()) {
        errors.fullName = "Please enter your full name!";
    } else if (values.fullName.length < 3) {
        errors.fullName = "Full name must be at least 3 characters!";
    }

    // Email Address validation
    if (!values.emailAddress) {
        errors.emailAddress = "Email is required!";
    } else if (!/^[A-Z0-9.%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.emailAddress)) {
        errors.emailAddress = "Please enter a valid email address!";
    }

    // Mobile Number validation (specific to India)
    if (country === 'India') {
        if (!values.mobileNumber) {
            errors.mobileNumber = "Mobile number is required!";
        } else if (values.mobileNumber.length !== 10) {
            errors.mobileNumber = "Mobile number must be exactly 10 digits!";
        } else if (!/^\d{10}$/.test(values.mobileNumber)) {
            errors.mobileNumber = "Mobile number must contain only numbers!";
        }
    }

    // Password validation
    const password = values.passWord;
    const uppercaseRegExp = /(?=.*?[A-Z])/;
    const lowercaseRegExp = /(?=.*?[a-z])/;
    const digitsRegExp = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    const minLengthRegExp = /.{8,}/;

    if (!password) {
        errors.passWord = "Password is required!";
    } else {
        if (!uppercaseRegExp.test(password)) {
            errors.passWord = "Password must contain at least one uppercase letter!";
        } else if (!lowercaseRegExp.test(password)) {
            errors.passWord = "Password must contain at least one lowercase letter!";
        } else if (!digitsRegExp.test(password)) {
            errors.passWord = "Password must contain at least one digit!";
        } else if (!specialCharRegExp.test(password)) {
            errors.passWord = "Password must contain at least one special character!";
        } else if (!minLengthRegExp.test(password)) {
            errors.passWord = "Password must be at least 8 characters long!";
        }
    }
    // console.log(errors);
    return errors;
}

function validatePersonalDetailsForm(values) {


    const errors = {};

    // Email or Mobile validation
    const emailOrMobileRegex = /\S+@\S+\.\S+/;
    const mobileRegex = /^\d{10}$/;

    if (!values.emailnmobi.trim()) {
        errors.emailnmobi = "Please enter an email address or mobile number!";
    } else if (!emailOrMobileRegex.test(values.emailnmobi) && !mobileRegex.test(values.emailnmobi)) {
        errors.emailnmobi = "Please enter a valid email address or mobile number!";
    }

    // if (!values.contactnumber.trim()) {
    //     errors.contactnumber = "Please enter a valid contact number!";
    // } 

    // Contact Number validation (optional - if different than emailnmobi)
    // const contactNumberRegex = /^\d{10}$/; // assuming a 10 digit mobile number
    // if (values.contactnumber && !contactNumberRegex.test(values.contactnumber)) {
    //     errors.contactnumber = "Please enter a valid contact number (10 digits).";
    // }

    // Company Name validation
    if (!values.companyName.trim()) {
        errors.companyName = "Company name is required!";
    }

    // Company Initials validation (optional: could restrict to 3-4 characters or letters only)
    if (!values.companyInitials.trim()) {
        errors.companyInitials = "Company initials are required!";
    } else if (values.companyInitials.length < 3 || values.companyInitials.length > 12) {
        errors.companyInitials = "Company initials must be between 3 and 6 characters!";
    }

    // Company Website validation (URL format)
    // const urlRegex = /^(https?:\/\/)?([\w\d\-]+\.)+[a-z]{2,6}(\.[a-z]{2})?([\/\w\d\-?&=]*)?$/;
    // if (values.companyWebsite && !urlRegex.test(values.companyWebsite)) {
    //     errors.companyWebsite = "Please enter a valid website URL!";
    // }

    // Company GST validation (basic example for 15 characters GST)
    const gstRegex = /^[A-Z0-9]{15}$/;
    if (values.companyGST && !gstRegex.test(values.companyGST)) {
        errors.companyGST = "Please enter a valid GST number!";
    }

    // Address1 validation (must be filled)
    if (!values.address1.trim()) {
        errors.address1 = "Address Line 1 is required!";
    }

    // Address2 validation (optional)
    if (values.address2 && values.address2.trim().length > 0 && values.address2.length < 5) {
        errors.address2 = "Address Line 2 must be at least 5 characters long!";
    }

    // // Country validation (required)
    // if (!values.country) {
    //     errors.country = "Country is required!";
    // }

    // // State validation (required)
    // if (!values.state) {
    //     errors.state = "State is required!";
    // }

    // // City validation (required)
    // if (!values.city) {
    //     errors.city = "City is required!";
    // }

    // Zip Code validation (you can adjust the regex for your region)
    const zipCodeRegex = /^[0-9]{6}$/; // assuming 5 digit ZIP code format
    if (!values.zipCode.trim()) {
        errors.zipCode = "Zip code is required!";
    } else if (!zipCodeRegex.test(values.zipCode)) {
        errors.zipCode = "Please enter a valid zip code!";
    }
    // console.log(errors)
    return errors;
}
export function validateAddCategoryForm(values) {
    // console.log({ values: values });
    const errors = {};
    // Category name validation
    if (values.CategoryName === '' || !values.CategoryName.trim()) {
        errors.CategoryName = "Category name is required!";
    } else if (values.CategoryName.length < 3) {
        errors.CategoryName = "Category name must be at least 3 characters long!";
    } else if (!/^[a-zA-Z0-9\s&]+$/.test(values.CategoryName)) {
        errors.CategoryName = "Category name can only contain letters, numbers, spaces, and the '&' character!";
    }
    return errors;
}

export function validateAddSubCategoryForm(values) {
    // console.log({ values: values });
    const errors = {};
    // Category name validation

    if (values.subCategoryName === '' || !values.subCategoryName.trim()) {
        errors.subCategoryName = "Category name is required!";
    } else if (values.subCategoryName.length < 3) {
        errors.subCategoryName = "Category name must be at least 3 characters long!";
    } else if (!/^[a-zA-Z0-9\s&]+$/.test(values.CategoryName)) {
        errors.CategoryName = "Category name can only contain letters, numbers, spaces, and the '&' character!";
    }
    return errors;
}

export function validateAddProductDetailsForm(values) {
    const errors = {};
    if (values.productName === '') {
        errors.productName = "Please Enter Product Name ! ";
    }
    else if (!values.productName.trim()) {
        errors.productName = "Please Enter Product Name ! ";
    }
    else if (values.productName.length < 2) {
        errors.productName = "Minimum 2 character require of product name ! ";
    }


    if (!values.productCode.trim()) {
        errors.productCode = "Please Enter Product Code ! ";
    }
    else if (values.productCode.length < 2) {
        errors.productCode = "Minimum 2 character required ! ";
    }
    if (values.productTax.length < 1) {
        errors.productTax = "Minimum 1 digit required ! ";
    }

    return errors;
}

export function validateAddProductVariantForm(values) {
    const errors = {};

    // Validate sellingUnit
    if (!values.sellingUnit) {
        errors.sellingUnit = "Please Enter selling unit";
    } else if (typeof values.sellingUnit === 'string' && !values.sellingUnit.trim()) {
        errors.sellingUnit = "Please Enter Product selling unit!";
    } else if (values.sellingUnit.length < 1) {
        errors.sellingUnit = "Minimum 1 digit require of product selling unit!";
    }

    // Validate sellingUnitPackingType
    // if (!values.sellingUnitPackingType) {
    //     errors.sellingUnitPackingType = "Please Enter selling Unit Packing Type";
    // } else if (typeof values.sellingUnitPackingType === 'string' && !values.sellingUnitPackingType.trim()) {
    //     errors.sellingUnitPackingType = "Please Enter selling Unit Packing Type!";
    // } else if (values.sellingUnitPackingType.length < 2) {
    //     errors.sellingUnitPackingType = "Minimum 2 character required!";
    // }
    // Selling Measurement (select dropdown)
    // if (!values.sellingMeasurement || values.sellingMeasurement === '') {
    //     errors.sellingMeasurement = "Please select a Selling Measurement";
    // }

    // Shipping Units

    if (!values.ShippingUnit) {
        errors.ShippingUnit = "Please enter Shipping Units";
    } else if (isNaN(values.ShippingUnit) || Number(values.ShippingUnit) <= 0) {
        errors.ShippingUnit = "Please enter a valid positive number";
    }

    // Shipping Unit Packing Type
    // if (!values.shippingUnitPackingType || values.shippingUnitPackingType.trim() === '') {
    //     errors.shippingUnitPackingType = "Please enter Shipping Unit Packing Type";
    // } else if (values.shippingUnitPackingType.trim().length < 2) {
    //     errors.shippingUnitPackingType = "Minimum 2 characters required";
    // }

    // Shipping Measurement (select dropdown)
    // if (!values.shippingMeasurement || values.shippingMeasurement === '') {
    //     errors.shippingMeasurement = "Please select a Shipping Measurement";
    // }

    // Variant
    if (!values.productVariant || values.productVariant.trim() === '') {
        errors.productVariant = "Please enter Variant";
    } else if (values.productVariant.trim().length < 2) {
        errors.productVariant = "Minimum 2 characters required";
    }

    // HSN Code
    // if (!values.hsnCode || values.hsnCode.trim() === '') {
    //     errors.hsnCode = "Please enter HSN Code";
    // } else if (!/^[0-9]{4,8}$/.test(values.hsnCode.trim())) {
    //     errors.hsnCode = "HSN Code must be 4-8 digits";
    // }

    // Best Before / Expiry
    // if (!values.bestBefore) {
    //     errors.bestBefore = "Please select Best Before/Expiry date";
    // } else if (new Date(values.bestBefore) < new Date()) {
    //     errors.bestBefore = "Date cannot be in the past";
    // }

    // Minimum Order Quantity
    // if (!values.minimumOrderQuantity) {
    //     errors.minimumOrderQuantity = "Please enter Minimum Order Quantity";
    // } else if (isNaN(values.minimumOrderQuantity) || Number(values.minimumOrderQuantity) <= 0) {
    //     errors.minimumOrderQuantity = "Please enter a valid positive number";
    // }

    // Product ID
    // if (!values.productId || values.productId.trim() === '') {
    //     errors.productId = "Please enter Product ID";
    // }

    // MRP
    if (!values.productMRP) {
        errors.productMRP = "Please enter MRP";
    } else if (isNaN(values.productMRP) || Number(values.productMRP) <= 0) {
        errors.productMRP = "Please enter a valid positive amount";
    }

    // Price
    if (!values.productPrice) {
        errors.productPrice = "Please enter Price";
    } else if (isNaN(values.productPrice) || Number(values.productPrice) <= 0) {
        errors.productPrice = "Please enter a valid positive amount";
    } else if (values.productMRP && Number(values.productPrice) > Number(values.productMRP)) {
        errors.productPrice = "Price cannot be higher than MRP";
    }

    // Link
    // if (values.link && values.link.trim() !== '') {
    //     try {
    //         new URL(values.link);
    //     } catch (e) {
    //         errors.link = "Please enter a valid URL";
    //     }
    // }

    // Available Stock
    // if (!values.availableStock && values.availableStock !== 0) {
    //     errors.availableStock = "Please enter Available Stock";
    // } else if (isNaN(values.availableStock) || Number(values.availableStock) < 0) {
    //     errors.availableStock = "Please enter a valid non-negative number";
    // }

    // Product Variant Image
    // if (!values.productVariantImage) {
    //     errors.productVariantImage = "Please upload a Product Variant Image";
    // }

    console.log({errors:errors})


    return errors;
}


export function validateSerachSupplierForm(values) {
    const errors = {};
    if (!values.searchSupplier) {
        errors.searchSupplier = "This Filed is required ! ";
    }

    else if (values.searchSupplier.length > 0 && values.searchSupplier.length <= 10) {
        let r = new RegExp(/^[0-9\b]+$/);
        if (!r.test(values.searchSupplier)) {
            errors.searchSupplier = "Only numbers allowed";
        }
    }

    return errors;
}
export function validateAddressForm(values) {
    let errors = {};

    // Helper function to check for empty, whitespace, or short strings
    const validateField = (fieldValue, fieldName, minLength = 3) => {
        if (!fieldValue || !fieldValue.trim()) {
            return `Please Enter ${fieldName} !`;
        }
        if (fieldValue.length < minLength) {
            return `${fieldName} must be at least ${minLength} characters !`;
        }
        return null;
    };

    // Validate address title
    const addressTitleError = validateField(values.addressTitle, "Address Title", 2);
    if (addressTitleError) {
        errors.addressTitle = addressTitleError;
    }

    // Validate address
    const addressError = validateField(values.address, "Address", 2);
    if (addressError) {
        errors.address = addressError;
    }

    return errors;
}

export function validateAddUserForm(formData, selectedusertype) {
    let errors = {};
    // console.log(formData);
    if (!formData.fullName) {
        errors.fullName = "This Filed is required ! ";
    }
    else if (formData.fullName.length < 3) {
        errors.fullName = "Minimum 3 character required ! ";
    }
    if (!formData.address) {
        errors.address = "This Filed is required ! ";
    }
    else if (formData.address.length < 3) {
        errors.address = "Minimum 5 character required ! ";
    }
    if (!formData.area) {
        errors.area = "This Filed is required ! ";
    }
    else if (formData.area.length < 3) {
        errors.area = "Minimum 5 character required ! ";
    }

    if (!formData.pincode) {
        errors.pincode = "This Filed is required ! ";
    }
    else if (formData.pincode.length < 3) {
        errors.pincode = "Minimum 3 character required ! ";
    }

    if (!formData.workpincode) {
        errors.workpincode = "This Filed is required ! ";
    }
    else if (formData.workpincode.length < 3) {
        errors.workpincode = "Minimum 3 character required ! ";
    }

    if (!formData.emailAddress) {
        errors.emailAddress = "Email is required";
    }
    else if (!/^[A-Z0-9.%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.emailAddress)) {
        errors.emailAddress = "Email Address is invalid";
    }
    if (!formData.primaryNumber) {
        errors.primaryNumber = "Mobile Number is required";
    }
    else if (formData.primaryNumber.length > 0 && formData.primaryNumber.length <= 10) {
        let r = new RegExp(/^[0-9\b]+$/);
        if (!r.test(formData.primaryNumber)) {
            errors.primaryNumber = "Only numbers allowed";
        }
    }
    else if (formData.primaryNumber.length < 10 || formData.primaryNumber.length > 10) {
        errors.primaryNumber = "Mobile number must be 10 digit";
    }


    if (!formData.secondaryNumber) {
        errors.secondaryNumber = "Mobile Number is required";
    }

    else if (formData.secondaryNumber.length > 0 && formData.secondaryNumber.length <= 10) {
        let r = new RegExp(/^[0-9\b]+$/);
        if (!r.test(formData.secondaryNumber)) {
            errors.secondaryNumber = "Only numbers allowed";
        }
    }
    else if (formData.secondaryNumber.length < 10 || formData.secondaryNumber.length > 10) {
        errors.secondaryNumber = "Mobile number must be 10 digit";
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    if (!formData.passWord || formData.passWord.trim() === "") {
        errors.passWord = "Password is required.";
    } else if (!passwordRegex.test(formData.passWord)) {
        errors.passWord =
            "Password must be 8+ chars with A, a, 1, and @.";
    }

    // Confirm New Password Validation
    if (!formData.confirmpassword || formData.confirmpassword.trim() === "") {
        errors.confirmpassword = "Confirm password is required.";
    } else if (formData.confirmpassword !== formData.passWord) {
        errors.confirmpassword = "Passwords do not match.";
    }


    if (!formData.userType) {
        errors.userType = "Please select a User Type!";
    }

    if (!formData.CountryId) {
        errors.CountryId = "Please select a country!";
    }
    if (!formData.StateId) {
        errors.selectedStateId = "Please select a State!";
    }
    if (!formData.CityId) {
        errors.selectedCityId = "Please select a City!";
    }

    if (!formData.WorkCountryId) {
        errors.selectedWorkCountryId = "Please select Work country!";
    }
    if (!formData.WorkStateId) {
        errors.selectedWorkStateId = "Please select Work State!";
    }
    if (!formData.WorkCityId) {
        errors.selectedWorkCityId = "Please select Work City!";
    }

    return errors;
}


export function validateProfile(formData) {
    let errors = {};
    if (!formData.username) {
        errors.username = "Username Is Required !!!"
    }
    if (!formData.mobilenum) {
        errors.mobilenum = "Mobile Number Is Required !!!"
    }
    if (!formData.email) {
        errors.email = " Email Is Required !!!"
    }
    if (!formData.address1) {
        errors.address1 = "Address Is Required !!!"
    }
    if (!formData.address2) {
        errors.address2 = " Address Is Required !!!"
    }
    if (!formData.pincode) {
        errors.pincode = " Pincode Is Required !!!"
    }
    return errors;
}

export function validateEditBadge(values) {
    let errors = {};
    if (!values.title) errors.title = 'Title is required';
    if (!values.bgcolor) errors.bgcolor = 'Background color is required';
    if (!values.textColor) errors.textColor = 'Text color is required';
    return errors;
}

export function validateEditwarehouse(values) {
    let errors = {};
    if (!values.title) errors.title = 'Title is required';
    if (!values.address) errors.address = 'Background color is required';
    return errors;
}
export function validateAddPriceListForm(values) {
    let errors = {};
    if (!values.state) errors.state = 'State is required';
    if (!values.city) errors.city = 'Background color is required';
    return errors;
}




// Exporting both validation functions
// export default { validateLoginForm, validateRegistrationForm, validatePersonalDetailsForm, validateAddSubCategoryForm, validateAddProductDetailsForm, validateSerachSupplierForm, validateAddressForm, validateAddUserForm, validateProfile, validateEditBadge, validateEditwarehouse };

// Create a named object containing all validation functions
const validationFunctions = {
    validateLoginForm,validateForgotPasswordForm,validateResetPasswordForm,
    validateRegistrationForm,
    validatePersonalDetailsForm,
    validateAddCategoryForm,
    validateAddSubCategoryForm,
    validateAddProductDetailsForm,
    validateAddProductVariantForm,
    validateSerachSupplierForm,
    validateAddressForm,
    validateAddUserForm,
    validateProfile,
    validateEditBadge,
    validateEditwarehouse,
    validateAddPriceListForm
};

// Export the named object as default
export default validationFunctions;